export default "__VITE_ASSET__BnnmRTn4__"